import React, { FC } from 'react';
import { AddressValidationForm } from '../AddressValidation';
import { AddPaymentProps } from './types';
import { Purchase } from '../types';
import { PaymentForm } from './PaymentForm';
import { WalletPicker } from './PaymentForm/WalletPicker';
import { useCheckoutAddPayment } from './useCheckoutAddPayment';

// The "upgrade" flow (the original V1 + PaymentSummary combo) — also what edit membership/billing
// info pages render, since they're the same PaymentForm mode="checkout" flow with a saved card
// already selected.
export const CheckoutAddPayment: FC<AddPaymentProps> = ({
  addPaymentError,
  addPaymentLoading,
  onAddPaymentOption,
  onUpdatePaymentOption,
  threeDActionContext,
  onThreeDActionError,
  currencyCode,
  countryCode,
  paywallLocation,
  allowCancel,
  onCompletePurchase,
  selectedPlan,
  currentPurchase,
  completedPurchase,
  completePurchaseLoading,
  completePurchaseError,
  selectedPaymentOption,
  wallet,
  onSelectPaymentOption,
  onNext,
  onCancel,
  onApplyCoupon,
  couponLoading,
  applyCouponError,
  onRemoveCoupon,
  showApplePayButton,
  onClickApplePay,
  requestRecurlyTokenAndValidate,
  handlePaymentPriorityChange,
  paymentMethodFormRef,
  paymentMethodFormikRef,
  setShowAddPaymentMethod,
  showAddPaymentMethod,
  purchaseableItems,
  closeBillingPopup,
  modalVariant,
  isModal,
  enableAnnualRenewal,
}) => {
  const {
    walletPickerProps,
    requiresBillingAddressBeforePurchase,
    handleUpgradeSubmit,
    handleAddCardDuringCheckout,
    handleCheckoutPayPalToken,
    pendingAddressIssue,
    resolveAddressIssue,
    dismissAddressIssue,
  } = useCheckoutAddPayment({
    showAddPaymentMethod,
    setShowAddPaymentMethod,
    threeDActionContext,
    wallet,
    selectedPaymentOption,
    onSelectPaymentOption,
    onUpdatePaymentOption,
    onAddPaymentOption,
    paymentMethodFormikRef,
    requestRecurlyTokenAndValidate,
    onCompletePurchase,
    onNext,
    isModal,
    paywallLocation,
  });

  return (
    <>
      <WalletPicker
        isWalletVisible={walletPickerProps.isWalletVisible}
        isBillingAddressEditable={walletPickerProps.isBillingAddressEditable}
        wallet={walletPickerProps.wallet}
        selectedPaymentOption={walletPickerProps.selectedPaymentOption}
        onSelectPaymentOption={walletPickerProps.onSelectPaymentOption}
        setShowAddPaymentMethod={walletPickerProps.setShowAddPaymentMethod}
        onUpdatePaymentOption={walletPickerProps.onUpdatePaymentOption}
        funnelEvents={walletPickerProps.funnelEvents}
      />
      <PaymentForm
        mode="checkout"
        onCancel={onCancel}
        addPaymentError={addPaymentError}
        addPaymentLoading={addPaymentLoading}
        allowCancel={allowCancel}
        threeDActionContext={threeDActionContext}
        currencyCode={currencyCode}
        countryCode={countryCode}
        paywallLocation={paywallLocation}
        currentPurchase={currentPurchase as Purchase}
        selectedPlan={selectedPlan}
        completedPurchase={completedPurchase}
        completePurchaseLoading={completePurchaseLoading}
        completePurchaseError={completePurchaseError}
        selectedPaymentOption={selectedPaymentOption}
        wallet={wallet}
        setShowAddPaymentMethod={setShowAddPaymentMethod}
        showAddPaymentMethod={showAddPaymentMethod}
        onApplyCoupon={onApplyCoupon}
        couponLoading={couponLoading}
        applyCouponError={applyCouponError}
        onRemoveCoupon={onRemoveCoupon}
        showApplePayButton={showApplePayButton}
        onClickApplePay={onClickApplePay}
        onSubmit={handleUpgradeSubmit}
        onAddCardDuringCheckout={handleAddCardDuringCheckout}
        onPayPalToken={handleCheckoutPayPalToken}
        handlePaymentPriorityChange={handlePaymentPriorityChange}
        paymentMethodFormRef={paymentMethodFormRef}
        paymentMethodFormikRef={paymentMethodFormikRef}
        purchaseableItems={purchaseableItems}
        closeBillingPopup={closeBillingPopup}
        modalVariant={modalVariant}
        isModal={isModal}
        enableAnnualRenewal={enableAnnualRenewal}
        allowPurchase={!showAddPaymentMethod && !requiresBillingAddressBeforePurchase}
        requireRegistrationPromoFlag={false}
        forceDecimalPricing
      />
      {pendingAddressIssue && (
        <AddressValidationForm
          result={pendingAddressIssue.result}
          currentAddress={pendingAddressIssue.currentAddress}
          lastCheckedInput={pendingAddressIssue.lastCheckedInput}
          onSubmit={resolveAddressIssue}
          onDismiss={dismissAddressIssue}
        />
      )}
    </>
  );
};
